import { Badge } from "components/ui/badge";
import { cn } from "utils";

import type { ResolvedSignal } from "./signal-utils";

/**
 * The one rendering of "the first pick is the badge signal": a filled,
 * prefixed badge for the first entry, outlined badges for the rest. Shared by
 * the overview card and the profile sheet so the convention cannot drift.
 */
export function SignalBadges({
  signals,
  className,
  testId,
}: {
  signals: ResolvedSignal[];
  className?: string;
  testId?: string;
}) {
  if (signals.length === 0) return null;
  return (
    <div
      className={cn("flex flex-wrap gap-1.5", className)}
      data-testid={testId}
    >
      {signals.map((signal, index) => (
        <Badge
          key={signal.id}
          variant={index === 0 ? "default" : "outline"}
          className={cn(
            "max-w-full min-w-0 shrink whitespace-normal wrap-anywhere rounded-lg text-left",
            // The badge signal is the person's own pick, not a status, so it
            // takes the brand purple rather than the success green.
            index === 0 && "bg-hb-purple-fill text-white",
          )}
        >
          {index === 0 ? `Badge · ${signal.label}` : signal.label}
        </Badge>
      ))}
    </div>
  );
}
